import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import textFieldInfo from '@/app/editor/sidebar/elementsInfo/textField';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'name',
    targetSelector: '.gf_textfield',
    property: 'name',
  },
  {
    type: 'html:attr',
    name: 'required',
    targetSelector: '.gf_textfield',
    property: 'required',
  },
  {
    type: 'html:attr',
    name: 'tf-placeholder',
    targetSelector: '.gf_textfield',
    property: 'placeholder',
  },
  {
    type: 'css',
    name: 'width',
    unit: '%',
    default_value: '',
    targetSelector: '.gf_textfield',
    property: 'width',
  },
  {
    type: 'css',
    name: 'height',
    unit: 'px',
    default_value: '',
    targetSelector: '.gf_textfield',
    property: 'height',
  },
  {
    type: 'css',
    name: 'font-size',
    targetSelector: '.gf_textfield',
    property: 'font-size',
    require: true,
  },
  {
    type: 'css',
    name: 'font',
    targetSelector: '.gf_textfield',
    property: 'font-family',
    require: true,
  },
  {
    type: 'css',
    name: 'text-color',
    targetSelector: '.gf_textfield',
    fieldType: 'color',
    property: 'color',
    require: true,
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.elm',
    property: 'align',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.elm',
    property: 'data-exc',
  },
];
/**
 * Button Atom Element
 */
export class GpTextField extends GpElement {
  public $el: JQuery;

  /**
   * [Hook] [override]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : textFieldInfo.settings;
  }

  /**
   * [Hook] [override]
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || textFieldInfo.name;
  }

  /**
   * [Hook] [override]
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || textFieldInfo.slug;
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * getClassName
   * @returns selector with Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + textFieldInfo.class;
  }
}
